import React from "react";
import { motion } from "framer-motion";
import { RevealLines } from "./Motion";
import { Overline } from "./Layout";

// Cinematic inner-page hero with parallax image and masked headline.
export const PageHero = ({ overline, titleLines, subtitle, image, align = "left", heightClass = "h-[68vh] min-h-[520px]", imgPosition = "object-center" }) => {
  return (
    <section className={`relative ${heightClass} w-full overflow-hidden bg-eucalyptus-deep`}>
      <motion.div
        initial={{ scale: 1.15 }}
        animate={{ scale: 1 }}
        transition={{ duration: 1.6, ease: [0.22, 1, 0.36, 1] }}
        className="absolute inset-0"
      >
        <img src={image} alt="" className={`h-full w-full object-cover ${imgPosition}`} />
        <div className="absolute inset-0 bg-gradient-to-t from-eucalyptus-deep/90 via-eucalyptus-deep/40 to-eucalyptus-deep/30" />
        <div className="grain absolute inset-0 opacity-40" />
      </motion.div>

      <div className="relative h-full mx-auto max-w-[88rem] px-6 lg:px-10 flex items-end pb-16">
        <div className={align === "center" ? "mx-auto text-center max-w-3xl" : "max-w-4xl"}>
          <motion.div
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-sandstone mb-5"
          >
            <Overline>{overline}</Overline>
          </motion.div>
          <h1 className="font-heading text-warmwhite font-semibold tracking-tighter leading-[0.95] text-5xl md:text-7xl">
            <RevealLines lines={titleLines} lineClassName="pb-1" />
          </h1>
          {subtitle && (
            <motion.p
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.9, delay: 0.4 }}
              className="mt-6 max-w-2xl text-lg text-warmwhite/80 leading-relaxed"
            >
              {subtitle}
            </motion.p>
          )}
        </div>
      </div>
    </section>
  );
};

export default PageHero;
